// magic numbers
export var BASE_BOX_WIDTH = 211;
export var BASE_HEADER_LOGO_WIDTH = 99;
export var TEXT_POSITION_X = 213;
export var TEXT_POSITION_Y = 49;
export var TEXT_SIZE = 66;
export var TRADEMARK_TEXT_SIZE = 16;
export var TRADEMARK_TEXT_WIDTH = 30; // these will eventually replace the standards above

var BIGEGG_BASE_BOX_WIDTH = 187;
var BIGEGG_BASE_HEADER_LOGO_WIDTH = 88;
export var BIGEGG_TEXT_POSITION_X = 201;
export var UVERSITY = 'Uversity'; // these numbers, along with the additionalHeaderLogoWidthByNavType numbers below,
// are essentially discovered through trial and error of the values to ensure:
// 1) the logo fits in the box
// 2) the "Chegg" portion of the logo shifts as minimally as possible

export var additionalBoxWidthByProductName = {
  Books: 178,
  Internships: 326,
  Prep: 138,
  'Math Solver': 358,
  Scholarships: 370,
  Study: 170,
  'Test Prep': 274,
  'ACT Test Prep': 422,
  'AP Test Prep': 383,
  'ASVAB Test Prep': 506,
  'GMAT Test Prep': 486,
  'GRE Test Prep': 427,
  'LSAT Test Prep': 444,
  'MCAT Test Prep': 477,
  'NCLEX-PN Test Prep': 624,
  'NCLEX-RN Test Prep': 622,
  'SAT Test Prep': 414,
  'Honor Shield': 377,
  Tutors: 183,
  Writing: 211,
  Money: 203,
  Faculty: 211,
  Life: 106,
  Perks: 165
};
var additionalHeaderLogoWidthByNavType = {
  Books: 84.5,
  Internships: 153.75,
  Prep: 65.5,
  'Math Solver': 169,
  Scholarships: 174.5,
  Study: 80.5,
  'Test Prep': 129.5,
  'ACT Test Prep': 199,
  'AP Test Prep': 180,
  'ASVAB Test Prep': 238,
  'GMAT Test Prep': 228,
  'GRE Test Prep': 200.25,
  'LSAT Test Prep': 208,
  'MCAT Test Prep': 224,
  'NCLEX-PN Test Prep': 292.5,
  'NCLEX-RN Test Prep': 292,
  'SAT Test Prep': 195,
  'Honor Shield': 178,
  Tutors: 87,
  Writing: 100,
  Money: 95.5,
  Faculty: 100,
  Life: 51,
  Perks: 80
};
var additionalBigEggHeaderLogoWidthByNavType = {
  Books: 90,
  Internships: 159.5,
  Prep: 71.25,
  'Math Solver': 174.5,
  Scholarships: 180,
  Study: 86.25,
  'Test Prep': 135,
  'ACT Test Prep': 204.5,
  'AP Test Prep': 186.25,
  'ASVAB Test Prep': 243.75,
  'GMAT Test Prep': 234.5,
  'GRE Test Prep': 206.75,
  'LSAT Test Prep': 214.75,
  'MCAT Test Prep': 230.25,
  'NCLEX-PN Test Prep': 299,
  'NCLEX-RN Test Prep': 298,
  'SAT Test Prep': 200.5,
  'Honor Shield': 182.5,
  Tutors: 92.25,
  Writing: 105.5,
  Money: 101.75,
  Faculty: 105.5,
  Life: 56,
  Perks: 85
};
export var getBoxWidthByProductName = function getBoxWidthByProductName(productName) {
  return productName ? TEXT_POSITION_X + additionalBoxWidthByProductName[productName] : BASE_BOX_WIDTH;
};
export var getBigEggBoxWidthByProductName = function getBigEggBoxWidthByProductName(productName) {
  return productName ? BIGEGG_TEXT_POSITION_X + additionalBoxWidthByProductName[productName] : BIGEGG_BASE_BOX_WIDTH;
};
export var getHeaderLogoWidthByProductName = function getHeaderLogoWidthByProductName(productName) {
  return productName ? BASE_HEADER_LOGO_WIDTH + additionalHeaderLogoWidthByNavType[productName] : BASE_HEADER_LOGO_WIDTH;
};
export var getBigEggHeaderLogoWidthByProductName = function getBigEggHeaderLogoWidthByProductName(productName) {
  return productName ? BIGEGG_BASE_HEADER_LOGO_WIDTH + additionalBigEggHeaderLogoWidthByNavType[productName] : BIGEGG_BASE_HEADER_LOGO_WIDTH;
};